import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './assets/theme';
import AuthContProvider from './context/auth.context';
import { LoadingProvider } from './context/loading.context';
import { NotificationProvider } from './context/notification.context';
import MainRoutes from './mainroute';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie'; // 👈 Import CookiesProvider

function App() {
  return (
    <CookiesProvider> {/* 👈 Wrap everything with CookiesProvider */}
      <ThemeProvider theme={theme}>
        <NotificationProvider>
          <AuthContProvider>
            <LoadingProvider>
                <MainRoutes />
            </LoadingProvider>
          </AuthContProvider>
        </NotificationProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;